import * as type from '../../../actions/index.types'

const initialState = {
    loading: false,
    listData: [],
    pagination: null,
    error: null,

    detailsLoading: false,
    details: null,

    createLoading: false,
    updateLoading: false,
    deleteLoading: false,

    previewLoading: false,
    preview: null,

    matureLoading: false,
    preMatureLoading: false,
    renewLoading: false,
};

export function InvestmentReducer(state = initialState, action) {
    switch (action.type) {
        // List
        case type.GET_INVESTMENTS:
            return { ...state, loading: true, error: null }
        case type.GET_INVESTMENTS_SUCCESS:
            return {
                ...state,
                loading: false,
                listData: action.payload?.data || [],
                pagination: action.payload?.meta?.pagination || null,
                error: null,
            }
        case type.GET_INVESTMENTS_FAILURE:
            return { ...state, loading: false, error: action?.message }

        // Details
        case type.GET_INVESTMENT_DETAILS:
            return { ...state, detailsLoading: true, details: null }
        case type.GET_INVESTMENT_DETAILS_SUCCESS:
            return { ...state, detailsLoading: false, details: action.payload?.data || null }
        case type.GET_INVESTMENT_DETAILS_FAILURE:
            return { ...state, detailsLoading: false }

        // Create
        case type.CREATE_INVESTMENT:
            return { ...state, createLoading: true }
        case type.CREATE_INVESTMENT_SUCCESS:
            return { ...state, createLoading: false }
        case type.CREATE_INVESTMENT_FAILURE:
            return { ...state, createLoading: false }

        // Update
        case type.UPDATE_INVESTMENT:
            return { ...state, updateLoading: true }
        case type.UPDATE_INVESTMENT_SUCCESS:
            return { ...state, updateLoading: false }
        case type.UPDATE_INVESTMENT_FAILURE:
            return { ...state, updateLoading: false }

        // Delete
        case type.DELETE_INVESTMENT:
            return { ...state, deleteLoading: true }
        case type.DELETE_INVESTMENT_SUCCESS:
            return { ...state, deleteLoading: false }
        case type.DELETE_INVESTMENT_FAILURE:
            return { ...state, deleteLoading: false }

        // Preview
        case type.CALCULATE_INVESTMENT_PREVIEW:
            return { ...state, previewLoading: true }
        case type.CALCULATE_INVESTMENT_PREVIEW_SUCCESS:
            return { ...state, previewLoading: false, preview: action.payload || null }
        case type.CALCULATE_INVESTMENT_PREVIEW_FAILURE:
            return { ...state, previewLoading: false, preview: null }

        case type.CLEAR_INVESTMENT_PREVIEW:
            return { ...state, preview: null, previewLoading: false }

        // Mature
        case type.MATURE_INVESTMENT:
            return { ...state, matureLoading: true }
        case type.MATURE_INVESTMENT_SUCCESS:
            return { ...state, matureLoading: false }
        case type.MATURE_INVESTMENT_FAILURE:
            return { ...state, matureLoading: false }

        // Pre-Mature
        case type.PRE_MATURE_INVESTMENT:
            return { ...state, preMatureLoading: true }
        case type.PRE_MATURE_INVESTMENT_SUCCESS:
            return { ...state, preMatureLoading: false }
        case type.PRE_MATURE_INVESTMENT_FAILURE:
            return { ...state, preMatureLoading: false }

        // Renew
        case type.RENEW_INVESTMENT:
            return { ...state, renewLoading: true }
        case type.RENEW_INVESTMENT_SUCCESS:
            return { ...state, renewLoading: false }
        case type.RENEW_INVESTMENT_FAILURE:
            return { ...state, renewLoading: false }

        case type.CLEAR_INVESTMENT_STATE:
            return { ...initialState }

        default:
            return state
    }
}
